import React from "react";
import { founder, contact } from "../../mock";
import { Eyebrow } from "../SectionHeading";
import Reveal from "../Reveal";
import { BadgeCheck, MessageCircle, Star } from "lucide-react";

const Founder = () => {
  return (
    <section className="py-20 md:py-28 relative overflow-hidden">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <Reveal>
          <div className="rounded-3xl border border-[#00ff87]/15 bg-gradient-to-br from-[#0c0d17] to-[#0a0a13] p-8 md:p-12">
            <div className="grid md:grid-cols-[auto_1fr] gap-8 md:gap-12 items-center">
              <div className="relative mx-auto">
                <div className="absolute inset-0 bg-[#00ff87]/25 blur-2xl rounded-full" />
                <img
                  src={founder.avatar}
                  alt={founder.name}
                  className="relative z-10 h-40 w-40 md:h-48 md:w-48 rounded-full object-cover border-2 border-[#00ff87]/50"
                />
              </div>
              <div>
                <Eyebrow>Meet the Founder</Eyebrow>
                <div className="flex items-center gap-2 mb-2">
                  <h3 className="font-display text-2xl md:text-3xl font-bold text-white">{founder.name}</h3>
                  <BadgeCheck size={24} className="text-[#00e5ff]" />
                </div>
                <p className="text-[#00ff87] font-medium mb-4">{founder.role}</p>
                <div className="flex gap-1 mb-4">
                  {[...Array(5)].map((_, i) => (
                    <Star key={i} size={18} className="text-yellow-400 fill-yellow-400" />
                  ))}
                </div>
                <p className="text-gray-400 leading-relaxed">{founder.bio}</p>
                <a
                  href={contact.whatsapp}
                  target="_blank"
                  rel="noreferrer"
                  className="btn-neon mt-6 inline-flex items-center gap-2 px-6 py-3 rounded-xl font-display font-semibold"
                >
                  <MessageCircle size={18} /> Chat with Us
                </a>
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};

export default Founder;
